import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  getRequest: {
    method: 'GET',
    url: `${configs.baseUrl}/api/auth/oauth/authorize/requests/{requestId}`,
  },
  decide: {
    method: 'POST',
    url: `${configs.baseUrl}/api/auth/oauth/authorize/decision`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getRequest = async (requestId) => {
  const res = await resource.getRequest({ requestId })
  return res.body
}

const decide = async ({ requestId, approve }) => {
  const res = await resource.decide({ request_id: requestId, approve })
  return res.body
}

export default {
  initResource,
  getRequest,
  decide,
}
